import React, {useState} from 'react';

import lang from '../../../lang/lang';

import { AddButtonStyled } from './AddButton.styled';

const AddButton = (props) => {
    const [langState, setLangState] = useState(localStorage.getItem('language') || 'en')

    return <>
        <AddButtonStyled
            onClick={props.onClick}
        >
            <span 
                className='icon-add-sign'
                title={langState === 'uk' ? lang.uk.addTodo : lang.en.addTodo}
            ></span>
        </AddButtonStyled>
    </>
}

export default AddButton;